import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import Tooltip from "../Tooltip";
// import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: (props) => props.backgroundColor,
    border: (props) => (props.border ? '1px solid #eee' : '0px'),
    padding: "0 !important"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: 230,
    width: `calc(100% - ${230}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '22px',
    letterSpacing: '0.25px',
    color: '#333',
    textOverflow: "ellipsis",
  },
  menuicon: {
    color: '#333',
  },
  header: {
    paddingLeft: "16px !important",
    paddingRight: "8px !important",
    "& button": {
      "&:hover svg": {
        stroke: theme.palette.hylyBlue
      },
      "&:hover path": {
        stroke: theme.palette.hylyBlue
      },

      "&:hover i": {
        color: theme.palette.hylyBlue
      },
      border: "none"
    }

  }
}));

const MenuBar = ({
  pageTitle,
  border,
  onMenuIconClicked,
  actions,
  backgroundColor,
  open,
  appswitcher,
  notification,
  xsWidth,
  onAppSwitcherClick
}) => {
  const classes = useStyles({ border, backgroundColor, open });

  return (
    <AppBar
      position='static'
      classes={{
        root: classes.root,
      }}
      elevation={0}
      className={open ? classes.appBarShift : classes.appBar}
    >
      <Toolbar className={classes.toolbar} classes={{
        gutters: classes.header
      }}>
        {!xsWidth ?
          (
            <IconButton
              edge='start'
              className={classes.menuButton}
              color='inherit'
              aria-label='menu'
              onClick={onMenuIconClicked}
            >
              <MenuIcon className={classes.menuicon} />
            </IconButton>
          ) : null}

        <Typography variant='body1' className={classes.title}>
          {pageTitle}
        </Typography>
        {actions.map(({ Component, props, children, keys }) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Component key={keys} {...props}>
            {children}
          </Component>
        ))}
        {
          // later replace these icons with original app switcher component and notification component
        }
        {notification && (
          <IconButton>
            <Notification />
          </IconButton>
        )}
        {appswitcher && (
          <Tooltip tooltip_text="App Switcher" placement="bottom">
            <IconButton onClick={onAppSwitcherClick}>
              <AppSwitcher />
            </IconButton>
          </Tooltip>

        )}
      </Toolbar>
    </AppBar>
  );
};

const MenuIcon = ({ stroke, fill }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="5.5" width="24" height="1" fill="black" />
    <rect x="4" y="11.5" width="24" height="1" fill="black" />
    <rect x="4" y="17.5" width="24" height="1" fill="black" />
  </svg>
);

const Notification = ({ stroke, fill }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.6667 12V8.66667C16.6667 7.42899 16.175 6.242 15.2998 5.36684C14.4247 4.49167 13.2377 4 12 4C10.7623 4 9.57534 4.49167 8.70017 5.36684C7.825 6.242 7.33333 7.42899 7.33333 8.66667V12C7.3135 13.6467 6.85312 15.2581 6 16.6667H18C17.1469 15.2581 16.6865 13.6467 16.6667 12Z'
      stroke='#333333'
      strokeMiterLimit='10'
      strokeLinecap='square'
    />
    <path
      d='M10.1104 17.9995C10.2489 18.3883 10.5043 18.7248 10.8416 18.9627C11.1789 19.2006 11.5816 19.3283 11.9944 19.3283C12.4071 19.3283 12.8098 19.2006 13.1471 18.9627C13.4844 18.7248 13.7398 18.3883 13.8784 17.9995H10.1104Z'
      fill='#333333'
    />
  </svg>
);

const AppSwitcher = ({ stroke, fill }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.5 7C3.5 8.933 5.067 10.5 7 10.5C8.933 10.5 10.5 8.933 10.5 7C10.5 5.067 8.933 3.5 7 3.5C5.067 3.5 3.5 5.067 3.5 7Z'
      stroke='#333333'
      strokeMiterLimit='10'
      strokeLinecap='square'
    />
    <path
      d='M13.5 7C13.5 8.933 15.067 10.5 17 10.5C18.933 10.5 20.5 8.933 20.5 7C20.5 5.067 18.933 3.5 17 3.5C15.067 3.5 13.5 5.067 13.5 7Z'
      stroke='#333333'
      strokeMiterLimit='10'
      strokeLinecap='square'
    />
    <path
      d='M3.5 17C3.5 18.933 5.067 20.5 7 20.5C8.933 20.5 10.5 18.933 10.5 17C10.5 15.067 8.933 13.5 7 13.5C5.067 13.5 3.5 15.067 3.5 17Z'
      stroke='#333333'
      strokeMiterLimit='10'
      strokeLinecap='square'
    />
    <path
      d='M13.5 17C13.5 18.933 15.067 20.5 17 20.5C18.933 20.5 20.5 18.933 20.5 17C20.5 15.067 18.933 13.5 17 13.5C15.067 13.5 13.5 15.067 13.5 17Z'
      stroke='#333333'
      strokeMiterLimit='10'
      strokeLinecap='square'
    />
  </svg>
);

MenuBar.propTypes = {
  backgroundColor: PropTypes.string,
  /**
   * title of active page
   */
  pageTitle: PropTypes.string,
  /**
   * to show border around menu bor or not
   */
  border: PropTypes.bool,
  /**
   * on menu click action to toggle navdrawer
   */
  onMenuIconClicked: PropTypes.func.isRequired,
  /**
   * Optional click handler
   * Example of action props
   * [
   * {
   *  Component: Button,
   *  props: { color: 'primary' },
   *   children: 'Click Me',
   * },
   *]
   */
  // eslint-disable-next-line react/forbid-prop-types
  actions: PropTypes.array,

  open: PropTypes.bool,
  /**
   * enable app switcher
   */
  appswitcher: PropTypes.bool,
  /**
   * enable notifications
   */
  notification: PropTypes.bool,
  xsWidth: PropTypes.bool,
};

MenuBar.defaultProps = {
  backgroundColor: '#fff',
  pageTitle: 'Page Title',
  border: false,
  open: false,
  actions: [],
  appswitcher: true,
  notification: true,
  xsWidth: false,
};

export default MenuBar;
